// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import Register from '../Register/Register';
import SubmitButton from '../../Util/SubmitButton/SubmitButton';

@inject('modalStore', 'userStore', 'messageStore')
@observer class Login extends Component<any, any> {

	@observable username = '';
	@observable password = '';
	@observable loading = false;


	constructor(props: any) {
		super(props);

		this.username = props.username ? props.username : '';

		this.login = this.login.bind(this);
		this.register = this.register.bind(this);
	}

	login(e: any): void {
		e.preventDefault();
		if(!this.loading) {
			if(this.username !== '' && this.password !== '') {
				this.loading = true;
				this.props.userStore.login(this.username, this.password).then((r: any) => {
					this.props.messageStore.setMessage('success', 'succefully logged in!', 2000);
					this.props.modalStore.removeModal();
					this.loading = false;
				}).catch((error: any) => {
					this.loading = false;
					this.props.messageStore.setMessage('error', error.message);
				});
			} else {
				if(this.username === '') {
					this.props.messageStore.setMessage('error', 'the username field cannot be empty!');
				} else {
					this.props.messageStore.setMessage('error', 'the password field cannot be empty!');
				}
			}
		}
	}

	register(e: any): void {
		e.preventDefault();

		this.props.modalStore.createModal('Register', (<Register />));
	}

	render() {
		return (
			<form onSubmit={this.login} className="user-form">
				<label>
					username:
					<input type="text" name="username" value={this.username} onChange={(e) => this.username = e.target.value}/>
				</label>
				<label>
					password:
					<input type="password" name="password" value={this.password} onChange={(e) => this.password = e.target.value}/>
				</label>
				<SubmitButton text="Login" loading={this.loading} />
				<p><a href="#" onClick={this.register}>Create an Account.</a></p>
			</form>
		)
	}
}

export default Login;